import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const EmployeeDetailPage = lazy(() => import('../pages/employee-detail/page'));
const RoadmapPage = lazy(() => import('../pages/roadmap/page'));
const SkillAssessmentPage = lazy(() => import('../pages/skill-assessment/page'));
const TimelinePage = lazy(() => import('../pages/timeline/page'));

const CaseStudyPage = lazy(() => import('../pages/case-study/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminLayout = lazy(() => import('../pages/admin/layout'));
const AdminDashboardPage = lazy(() => import('../pages/admin/page'));
const AdminEmployeesPage = lazy(() => import('../pages/admin/employees/page'));
const AdminTimelinePage = lazy(() => import('../pages/admin/timeline/page'));
const AdminCasesPage = lazy(() => import('../pages/admin/cases/page'));
const AdminTokenUsagePage = lazy(() => import('../pages/admin/token-usage/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/employee/:id',
    element: <EmployeeDetailPage />,
  },
  {
    path: '/roadmap',
    element: <RoadmapPage />,
  },
  {
    path: '/skill-assessment',
    element: <SkillAssessmentPage />,
  },
  {
    path: '/timeline',
    element: <TimelinePage />,
  },

  {
    path: '/case-study',
    element: <CaseStudyPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <AdminDashboardPage />,
      },
      {
        path: 'employees',
        element: <AdminEmployeesPage />,
      },
      {
        path: 'timeline',
        element: <AdminTimelinePage />,
      },
      {
        path: 'cases',
        element: <AdminCasesPage />,
      },
      {
        path: 'token-usage',
        element: <AdminTokenUsagePage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;